import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button, Typography } from '@mui/material';

interface PaymentProviderDisableModalProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    disableProvider: () => void;
}

export const PaymentProviderDisableModal = ({
    isOpen,
    setIsOpen,
    disableProvider,
}: PaymentProviderDisableModalProps) => {
    const onClose = () => {
        setIsOpen(false);
    };
    const onConfirm = () => {
        disableProvider();
        setIsOpen(false);
    };
    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogContent>
                <Typography variant="body1">
                    Are you sure you want to disable this payment provider?.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onConfirm} variant="contained" color="primary">
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};
